import nuevaPostulacion from '@/views/Helexium/Postulantes/componentesNuevaPostulacion/storeNuevaPostulacion.js';
import schemas from './modules/schemas.js'
import sourceData from './modules/sourceData.js'
import lego from './modules/lego.js'

export default {
    nuevaPostulacion,
    schemas,
    sourceData,
    lego
}